import { create_div } from 'js/utils';
import Hooks from 'classes/Hooks';

export default class Mega_Menu {

    constructor(args = {}){

        this.args = args;

        this.trigger = args.trigger;
        this.destination = args.destination;
        
        this.is_open = false;
        this.init();
    }
    
    init(){

        this.hooks = new Hooks([
            'open',
            'close'
        ]);

        this.init_container();
        this.init_listeners();

        if( this.args.animate_height ) {
            this.init_animate_height();
        }
    }

    init_container(){

        const con = create_div('mega_menu_sub', this.destination);
        con.style.display = 'none';
        con.classList.add(get_elementor_class(this.args.el.parentElement));
        con.append(this.args.el);
        
        this.container = con
    }

    init_listeners(){
        
        this.close_timeout = null;
        
        const leave_handler = ()=>{
            
            this.close_timeout = setTimeout(()=>{
                this.close();
            }, 500)

        }

        this.trigger.addEventListener('pointerenter', ()=>{
            this.open();
        })

        this.trigger.addEventListener('pointerleave', leave_handler)

        this.destination.addEventListener('pointerenter', ()=>{
            if( !this.is_open ) return;
            this.open();
        })

        this.destination.addEventListener('pointerleave', leave_handler)
    }

    open(){

        if( this.close_timeout ) {
            clearTimeout(this.close_timeout);
        }

        if( this.is_open ) return;
        
        this.is_open = true;
        
        this.trigger.classList.add('mm_open')
        
        this.container.style.display = '';

        this.container.classList.add('mm_open')
        
        this.hooks.do('open')
    }

    close(){

        if( !this.is_open ) return;
        this.is_open = false;
        
        this.trigger.classList.remove('mm_open')
        this.container.style.display = 'none';
        this.container.classList.remove('mm_open')

        this.hooks.do('close')
    }

    init_animate_height(){

        const con = create_div('mega_menu_sub_wrap')
        this.container.before(con);
        con.append(this.container);

        con.style.height = 0;
        
        this.hooks.add('open', ()=>{
            con.style.transition = '';
            con.style.height = this.container.offsetHeight + 'px';
        })

        this.hooks.add('close', ()=>{
            con.style.transition = 'none';
            con.style.height = 0;
        })
    }
    
}

function get_elementor_class(el){
    for( const class_name of el.className.split(' ')){
        if( class_name.includes('elementor-') ) {
            return class_name;
        }
    }
    return '';
}